import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const titles = [
  { title: "Permaisuri Terbuang", zh: "废妃归来", revenue: "RM 2,800K+", genre: "Royal & Elite" },
  { title: "TIPU BALAS", zh: "利刃玫瑰", revenue: "RM 2,700K+", genre: "Revenge" },
  { title: "AKU KAHWIN MAFIA", zh: "我和黑帮大佬闪婚", revenue: "RM 2,600K+", genre: "Romance" },
  { title: "DAH MATI Hati", zh: "家族的重生逆袭", revenue: "RM 1,950K+", genre: "Transformation" },
  { title: "Isteri Manja", zh: "重生娇妻", revenue: "RM 1,600K+", genre: "Romance" },
  { title: "MamaMafiaAnakTiga", zh: "天降三宝", revenue: "RM 1,600K+", genre: "Family" },
  { title: "AYAHKU", zh: "父如高楼", revenue: "RM 1,400K+", genre: "Family" },
  { title: "ROTI DAN EMAS", zh: "面包与金币", revenue: "RM 700K+", genre: "Drama" },
];

const genreColors: Record<string, string> = {
  "Royal & Elite": "#c8a96e",
  "Revenge": "#e05c5c",
  "Romance": "#e07b9e",
  "Transformation": "#7bc4e0",
  "Family": "#82c996",
  "Drama": "#b07be0",
};

const HitTitles = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ padding: "100px 40px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={visible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
            <div style={{ width: 36, height: 2, background: "#FF1C35" }} />
            <span style={{ color: "#FF1C35", fontSize: 12, fontWeight: 700, letterSpacing: 3 }}>PROVEN HITS · 爆款作品</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16, marginBottom: 48 }}>
            <h2 style={{ fontSize: "clamp(28px, 4vw, 44px)", fontWeight: 900, lineHeight: 1.1, margin: 0 }}>
              Hit Titles with<br /><span style={{ color: "#FF1C35" }}>Proven Revenue</span>
            </h2>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, margin: 0, maxWidth: 340 }}>
              Each title validated in-market — average production cost ~RM 195K,<br />with top hits delivering 10x+ returns.
            </p>
          </div>
        </motion.div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 16 }}>
          {titles.map((t, i) => (
            <motion.div key={t.title}
              initial={{ opacity: 0, y: 20 }}
              animate={visible ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              whileHover={{ y: -4, borderColor: "rgba(255,28,53,0.35)" } as never}
              style={{
                padding: "24px 22px", borderRadius: 14,
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.07)",
                transition: "all 0.3s",
                cursor: "default",
              }}
            >
              <div style={{
                display: "inline-block", marginBottom: 14,
                padding: "4px 10px", borderRadius: 999, fontSize: 11, fontWeight: 600,
                background: `${genreColors[t.genre] || "#FF1C35"}18`,
                color: genreColors[t.genre] || "#FF1C35",
                border: `1px solid ${genreColors[t.genre] || "#FF1C35"}30`,
              }}>{t.genre}</div>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#fff", lineHeight: 1.3, marginBottom: 4 }}>{t.title}</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 16 }}>{t.zh}</div>
              <div style={{
                display: "flex", alignItems: "center", gap: 8,
                paddingTop: 14, borderTop: "1px solid rgba(255,255,255,0.07)",
              }}>
                <span style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>Revenue</span>
                <span style={{ fontSize: 15, fontWeight: 800, color: "#FF1C35", fontFamily: "JetBrains Mono, monospace" }}>{t.revenue}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0 }} animate={visible ? { opacity: 1 } : {}} transition={{ delay: 0.8 }}
          style={{
            marginTop: 40, padding: "24px 32px", borderRadius: 14,
            background: "linear-gradient(135deg, rgba(255,28,53,0.08) 0%, rgba(255,28,53,0.03) 100%)",
            border: "1px solid rgba(255,28,53,0.15)",
            display: "flex", justifyContent: "space-around", flexWrap: "wrap", gap: 24,
          }}>
          {[["RM 16M+", "Total Revenue"], ["2x–3x+", "ROI on Hit Projects"], ["1.1x–1.2x", "Baseline ROI"]].map(([v, l]) => (
            <div key={l} style={{ textAlign: "center" }}>
              <div style={{ fontSize: 28, fontWeight: 900, color: "#FF1C35", fontFamily: "JetBrains Mono, monospace" }}>{v}</div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginTop: 4 }}>{l}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HitTitles;
